import { createContext, use } from 'react';
import { translations, type Language, type TranslationKey } from './translations';

type TranslationParams = Record<string, string | number>;

export interface I18nContextValue {
  language: Language;
  locale: string;
  setLanguage: (language: Language) => void;
  t: (key: TranslationKey, params?: TranslationParams) => string;
  et: (source: string, params?: TranslationParams) => string;
}

export const I18nContext = createContext<I18nContextValue | null>(null);

function interpolate(template: string, params?: TranslationParams) {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.hasOwn(params, name) ? String(params[name]) : match,
  );
}

const FALLBACK_I18N: I18nContextValue = {
  language: 'ru',
  locale: 'ru-RU',
  setLanguage: () => {},
  t: (key, params) => interpolate(translations.ru[key], params),
  et: (source, params) => interpolate(source, params),
};

export function useI18n() {
  const context = use(I18nContext);
  return context ?? FALLBACK_I18N;
}
